export enum actionTypes {
  //FetchReadingMaterials
  FETCH_READING_MATERIALS_REQUEST = "FETCH_READING_MATERIALS_REQUEST",
  FETCH_READING_MATERIALS_SUCCESS = "FETCH_READING_MATERIALS_SUCCESS",
  FETCH_READING_MATERIALS_FAIL = "FETCH_READING_MATERIALS_FAIL",
  //CreateReadingMaterial
  CREATE_READING_MATERIAL_REQUEST = "CREATE_READING_MATERIAL_REQUEST",
  CREATE_READING_MATERIAL_SUCCESS = "CREATE_READING_MATERIAL_SUCCESS",
  CREATE_READING_MATERIAL_FAIL = "CREATE_READING_MATERIAL_FAIL",
  //UpdateReadingMaterial
  UPDATE_READING_MATERIAL_REQUEST = "UPDATE_READING_MATERIAL_REQUEST",
  UPDATE_READING_MATERIAL_SUCCESS = "UPDATE_READING_MATERIAL_SUCCESS",
  UPDATE_READING_MATERIAL_FAIL = "UPDATE_READING_MATERIAL_FAIL",
  //DeleteReadingMaterial
  DELETE_READING_MATERIAL_REQUEST = "DELETE_READING_MATERIAL_REQUEST",
  DELETE_READING_MATERIAL_SUCCESS = "DELETE_READING_MATERIAL_SUCCESS",
  DELETE_READING_MATERIAL_FAIL = "DELETE_READING_MATERIAL_FAIL",
}

export interface GenericGroupStateProps {
  isLoading: boolean;
  status: stateStatusType | null;
  error: string | null;
}

export enum stateStatusType {
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}

export interface ReadingMaterialProps {
  id: string;
  name: string;
  pdf: string;
  video_id: string;
  description: string;
}

export interface ReadingMaterialInput {
  description: string;
  pdf?:string;
  pdfFile?: File | null;
  name: string;
  video_id: string;
}
export interface ReadingMaterialError {
  description?: string;
  pdf?: string;
  name?: string;
}

//FetchReadingMaterials
export interface FetchReadingMaterialsRequestAction {
  type: actionTypes.FETCH_READING_MATERIALS_REQUEST;
}

export interface FetchReadingMaterialsSuccessAction {
  type: actionTypes.FETCH_READING_MATERIALS_SUCCESS;
  payload: ReadingMaterialProps;
}

export interface FetchReadingMaterialsFailureAction {
  type: actionTypes.FETCH_READING_MATERIALS_FAIL;
  payload: string;
}
//CreateReadingMaterial
export interface CreateReadingMaterialRequestAction {
  type: actionTypes.CREATE_READING_MATERIAL_REQUEST;
}
export interface CreateReadingMaterialSuccessAction {
  type: actionTypes.CREATE_READING_MATERIAL_SUCCESS;
  payload: ReadingMaterialProps;
}
export interface CreateReadingMaterialFailAction {
  type: actionTypes.CREATE_READING_MATERIAL_FAIL;
  payload: string;
}
//UpdateReadingMaterial
export interface UpdateReadingMaterialRequestAction {
  type: actionTypes.UPDATE_READING_MATERIAL_REQUEST;
}
export interface UpdateReadingMaterialSuccessAction {
  type: actionTypes.UPDATE_READING_MATERIAL_SUCCESS;
  payload: ReadingMaterialProps;
}
export interface UpdateReadingMaterialFailAction {
  type: actionTypes.UPDATE_READING_MATERIAL_FAIL;
  payload: string;
}
//DeleteReadingMaterial
export interface DeleteReadingMaterialRequestAction {
  type: actionTypes.DELETE_READING_MATERIAL_REQUEST;
}
export interface DeleteReadingMaterialSuccessAction {
  type: actionTypes.DELETE_READING_MATERIAL_SUCCESS;
  payload: string;
}
export interface DeleteReadingMaterialFailAction {
  type: actionTypes.DELETE_READING_MATERIAL_FAIL;
  payload: string;
}

export type ReadingMaterialActions =
  | FetchReadingMaterialsRequestAction
  | FetchReadingMaterialsSuccessAction
  | FetchReadingMaterialsFailureAction
  | CreateReadingMaterialRequestAction
  | CreateReadingMaterialSuccessAction
  | CreateReadingMaterialFailAction
  | UpdateReadingMaterialRequestAction
  | UpdateReadingMaterialSuccessAction
  | UpdateReadingMaterialFailAction
  | DeleteReadingMaterialRequestAction
  | DeleteReadingMaterialSuccessAction
  | DeleteReadingMaterialFailAction;
